import {Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, useDisclosure,
    Button, Tooltip } from '@chakra-ui/react'
import { BsPrinter } from "react-icons/bs"
import { useRef, useState } from 'react'
import { PDFViewer } from '@react-pdf/renderer'
import PDFReceipt from './PDFReceipt'
import { useNavigate } from "react-router-dom";
import authService from "../services/authService"
import moment from 'moment'

const PrintPDFReceipt = ({ idReceipt }) => {
    const { isOpen, onOpen, onClose } = useDisclosure()
    const initialRef = useRef(null)
    let [ form, setForm ] = useState({})

    const navigate = useNavigate();

    const handleOpen = () => {
        const accessToken = localStorage.getItem("user")

        moment.locale("es")
        
        fetch("https://api.veterinariacajeao.com.ar/api/receipt/" + idReceipt, {
            headers: {
                'Content-Type': 'application/json',
                "x-auth-token": accessToken
            }
        })
        .then(response => response.json())
        .then(data => {
            setForm(form = {
                customerName: data.customer.name,
                customerStreet: data.customer.street,
                customerIva: data.customer.ivaName,
                customerCity: data.customer.city,
                customerCuit: data.customer.cuit,
                customerState: data.customer.stateName,
                receiptNumber: data.receiptNumber,
                date: moment(data.date).add(3,"h").format("L"),
                payments: data.payments,
                observations: data.observations,
                paid: data.amount
            })
        })
        .catch(error => {
            console.log(error)
            /*authService.logout()
            navigate("/");
            window.location.reload();*/
        })
        
        onOpen()
    }

    return (
        <>
            <Tooltip label='Imprimir'><Button size="sm" colorScheme='messenger' onClick={handleOpen}><BsPrinter/></Button></Tooltip>

            <Modal
                initialFocusRef={initialRef}
                isOpen={isOpen}
                onClose={onClose}
                size='3xl'
            >
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Recibo</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody pb={6}>
                        <PDFViewer width="720px" height="400px">
                            <PDFReceipt {...form}/>
                        </PDFViewer>
                    </ModalBody>

                </ModalContent>
            </Modal>
        </>
    )
}

export default PrintPDFReceipt